module.exports = __webpack_public_path__ + "static/media/building.a1fc6467.jpg";